export var VehicleType;
(function (VehicleType) {
    VehicleType["Bus"] = "Bus";
    VehicleType["Car"] = "Car";
    VehicleType["Motorcycle"] = "Motorcycle";
    VehicleType["RoadVehicle"] = "RoadVehicle";
    VehicleType["Tractor"] = "Tractor";
    VehicleType["Trailer"] = "Trailer";
    VehicleType["Truck"] = "Truck";
    VehicleType["allTerrainScooter"] = "allTerrainScooter";
    VehicleType["allTerrainTrailer"] = "allTerrainTrailer";
    VehicleType["fourWheeler"] = "fourWheeler";
    VehicleType["heavyEquipment"] = "heavyEquipment";
    VehicleType["Moped"] = "Moped";
    VehicleType["SnowMobile"] = "SnowMobile";
})(VehicleType || (VehicleType = {}));
